var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-container',{staticClass:"kst-stock-list"},[_c('kst-form',{attrs:{"title":_vm.title}},[_c('ListCatalog'),_c('kst-divider'),_c('Mixin'),_c('kst-divider'),_c('Formatted'),_c('kst-divider'),_c('Simple')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }